import React , {Component} from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Loader } from '../../components/base';

import { logoutUrl } from '../../constants/urls';

const styles = theme => ({
  container: {
    height: '100vh',
    width: '100vw',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }
});

class LogoutView extends Component {
  componentDidMount() {
    window.location = logoutUrl();
  }

  render() {
    const {classes: c} = this.props;

    return (
      <div className={c.container}>
        <Loader color='secondary' />
      </div>
    )
  }
}


export default withStyles(styles)(LogoutView);



// WEBPACK FOOTER //
// ./src/views/Logout/LogoutView.js